import React from 'react'

// Default AQUA brand gradient. Overridable via the `gradient` prop so customers
// can match the title text to their own logo (see branding.logo_text_gradient).
export const DEFAULT_LOGO_GRADIENT =
  'linear-gradient(105deg, #ea580c 0%, #f97316 18%, #e11d48 42%, #a855f7 72%, #6d28d9 100%)'

export const AquaLogo: React.FC<{
  size?: number
  className?: string
  text?: string
  /** CSS `background` value (gradient or solid color) applied to the text. */
  gradient?: string
}> = ({ size = 20, className = '', text = 'AQUA', gradient = DEFAULT_LOGO_GRADIENT }) => (
  <span
    className={className}
    style={{
      display: 'inline-block',
      fontWeight: 800,
      fontSize: size,
      lineHeight: 1.2,
      paddingBottom: '0.1em',
      letterSpacing: '-0.02em',
      background: gradient,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    }}
    aria-hidden="true"
  >
    {text}
  </span>
)
